// import React, { useCallback } from "react";
// import { loadStripe } from "@stripe/stripe-js";
// import {
//   EmbeddedCheckoutProvider,
//   EmbeddedCheckout,
// } from "@stripe/react-stripe-js";
// import { useCart } from "../contexts/CartContext";

// const stripeToken = process.env.REACT_APP_STRIPE_TOKEN;
// const stripePromise = loadStripe(stripeToken);

// function StripeMealPayment() {
//   const { cart } = useCart();

//   const fetchClientSecret = useCallback(async () => {
//     try {
//       // Get user token from localStorage
//       let user = localStorage.getItem("loggedInUser");
//       let token = "";
//       if (user && user !== "undefined") {
//         user = JSON.parse(user);
//         token = user?.token || "";
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_URL}web/cart/online-payment-checkout-for-meal-subscription`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             ...(token && { Authorization: `Bearer ${token}` }),
//           },
//           body: JSON.stringify({
//             mealSubscriptionCartId: cart?.mealCart?._id,
//           }),
//         }
//       );

//       const data = await response.json();
//       // console.log("🔍 Backend response:", data);

//       if (data?.clientSecret) {
//         // console.log("✅ Client secret:", data.clientSecret);
//         return data.clientSecret;
//       } else {
//         console.error("❌ Missing clientSecret in response", data);
//         throw new Error("Missing clientSecret in backend response");
//       }
//     } catch (error) {
//       console.error("⚠️ fetchClientSecret error:", error);
//       throw error;
//     }
//   }, [cart]);

//   const options = { fetchClientSecret };

//   return (
//     <div id="checkout">
//       <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
//         <EmbeddedCheckout />
//       </EmbeddedCheckoutProvider>
//     </div>
//   );
// }

// export default StripeMealPayment;

import React, { useCallback, useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { useCart } from "../contexts/CartContext";
import Modal from "../common/Modal"; // your modal component
import FullScreenLoading from "../common/loading/FullScreenLoading"; // optional full-screen loader
import { useNavigate } from "react-router-dom";

const stripeToken = process.env.REACT_APP_STRIPE_TOKEN;
const stripePromise = loadStripe(stripeToken);

export default function StripeMealPayment() {
  const { cart } = useCart();
  const [clientSecret, setClientSecret] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const fetchClientSecret = useCallback(async () => {
    try {
      setLoading(true);

      // Get user token from localStorage
      let user = localStorage.getItem("loggedInUser");
      let token = "";
      if (user && user !== "undefined") {
        user = JSON.parse(user);
        token = user?.token || "";
      }

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}web/cart/online-payment-checkout-for-meal-subscription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({
            mealSubscriptionCartId: cart?.mealCart?._id,
          }),
        }
      );

      const data = await response.json();

      if (data?.clientSecret && typeof data.clientSecret === "string") {
        setClientSecret(data.clientSecret);
        setError(null);
        return data.clientSecret;
      } else {
        throw new Error("Payment initiation failed. Please try again.");
      }
    } catch (err) {
      console.error("⚠️ fetchClientSecret error:", err);
      setClientSecret(null);
      setError("Payment initiation failed. Please try again.");
      return null;
    } finally {
      setLoading(false);
    }
  }, [cart?.mealCart?._id]);

  // Fetch client secret on mount
  useEffect(() => {
    fetchClientSecret();
  }, [fetchClientSecret]);

  return (
    <div id="checkout">
      {/* Error Modal */}
      {error && (
        <Modal
          isOpen={!!error}
          onClose={() => navigate(-1)}
          title="Payment Error"
          onConfirm={() => navigate(-1)} // retry fetching client secret
          confirmButton="Retry Payment"
          dismissible={false}
          showCancel={false}
        >
          <div className="font-mono">
            <p>{error}</p>
          </div>
        </Modal>
      )}

      {/* Render Stripe only if clientSecret is available */}
      {clientSecret && (
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{ fetchClientSecret: () => clientSecret }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      )}

      {/* Loading indicator */}
     {!clientSecret && !error && <FullScreenLoading />}
    </div>
  );
}
